export enum DeductionsSettingTypes {
  ALL = "all",
  ONLY_401K = "401k",
  NONE = "none",
}
